/* Desert Route buybox wiring. Paired with snippets/desert-route-buybox.liquid.
   Per-element idempotency (root.dataset.drbWired), re-wires on shopify:section:load,
   so it keeps working inside the theme editor. No global one-time flag. */
(function () {
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var f = fmt || '${{amount}}';
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function weeksOf(label) {
    var m = String(label || '').match(/(\d+)\s*week/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function wire(root) {
    if (!root || root.dataset.drbWired) return;
    var dataEl = root.querySelector('[data-drb-plans]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.drbWired = '1';

    var fmt = root.getAttribute('data-money-format');
    var variantInput = root.querySelector('[data-drb-variant]');
    var planInput = root.querySelector('[data-drb-plan]');
    var cadenceRow = root.querySelector('[data-drb-cadence]');
    var cadSelect = root.querySelector('[data-drb-cad]');
    var ctaText = root.querySelector('[data-drb-cta-text]');
    var ctaBtn = root.querySelector('button[type="submit"]');
    var opts = root.querySelectorAll('[data-drb-opt]');
    var sticks = {
      route: parseInt(root.getAttribute('data-sticks-route'), 10) || 0,
      season: parseInt(root.getAttribute('data-sticks-season'), 10) || 0
    };

    // Show cadences shortest first, whatever order the plan group stores them in.
    if (cadSelect) {
      var list = Array.prototype.slice.call(cadSelect.options);
      list.sort(function (a, b) { return (weeksOf(a.text) || 999) - (weeksOf(b.text) || 999); });
      list.forEach(function (o) { cadSelect.appendChild(o); });
    }

    function planLabel(id) {
      var p = (data.plans || []).filter(function (x) { return String(x.id) === String(id); })[0];
      if (!p) return '';
      return String(p.name || p.label).replace(/^Deliver(y)? every\s*/i, 'Every ');
    }

    function current() {
      var c = root.querySelector('[data-drb-opt] input:checked');
      return c ? c.value : 'route';
    }

    function renderLines() {
      ['route', 'season'].forEach(function (key) {
        var line = root.querySelector('[data-drb-line="' + key + '"]');
        var v = data.variants && data.variants[key];
        if (!line || !v) return;
        var planId = (current() === key && cadSelect) ? cadSelect.value : data.defaults[key];
        var perGlass = sticks[key] ? Math.round(v.price / sticks[key]) : 0;
        var parts = [];
        var cad = planLabel(planId);
        if (cad) parts.push(cad + '.');
        if (perGlass) parts.push(money(perGlass, fmt) + ' a glass.');
        var tail = line.getAttribute('data-tail');
        if (tail) parts.push(tail);
        line.textContent = parts.join(' ');
      });
    }

    function select(key, keepCadence) {
      opts.forEach(function (o) {
        var on = o.getAttribute('data-drb-opt') === key;
        o.classList.toggle('is-active', on);
        var input = o.querySelector('input');
        if (input) input.checked = on;
      });
      var isSub = key === 'route' || key === 'season';
      var v = data.variants[key] || data.variants.route;
      if (variantInput && v) variantInput.value = v.id;
      if (cadenceRow) cadenceRow.hidden = !isSub;
      if (isSub && cadSelect && !keepCadence && data.defaults[key]) cadSelect.value = String(data.defaults[key]);
      if (planInput) {
        // With no cadence <select> (homepage buybox) fall back to the tier's default plan
        // so the subscription still carries a selling_plan. PDP keeps the select.
        planInput.value = isSub ? (cadSelect ? cadSelect.value : (data.defaults[key] || '')) : '';
        planInput.disabled = !isSub; // one-time: no selling_plan param at all
      }
      if (ctaText) ctaText.textContent = isSub ? data.cta.sub : data.cta.once;
      if (ctaBtn) {
        if (v && v.available === false) ctaBtn.setAttribute('disabled', 'disabled');
        else ctaBtn.removeAttribute('disabled');
      }
      renderLines();
    }

    opts.forEach(function (o) {
      var input = o.querySelector('input');
      if (input) input.addEventListener('change', function () { select(input.value); });
    });
    if (cadSelect) cadSelect.addEventListener('change', function () {
      if (planInput && !planInput.disabled) planInput.value = cadSelect.value;
      renderLines();
    });

    // Deep link: ?route=season|once or #buy-box keeps the Route pre-selected by default.
    var want = 'route';
    try {
      var q = new URLSearchParams(window.location.search).get('route');
      if (q === 'season' || q === 'once') want = q;
    } catch (e) {}
    select(want);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-drb]').forEach(wire);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target.closest('.shopify-section') || document); });
})();
